export const IS_LOGGED = '706630'
export const TRUE = 'Y35'
export const FALSE = 'N0'

export const defaultUsername = 'nazarenoesperanza'
export const defaultPassword = '2024Eternidad***'